import React from 'react'

function GetStarted() {
    return (
        <div class="idocs-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                    <section id="idocs_layout">
                            <h1>Welcome to Safexpay!</h1>
                            <hr />
                            <p class="mt-30">To start using our products, you'll need to create and activate a Safexpay merchant account. This is a quick and easy three-step process:</p>
                            <ul>
                                <li>1. Sign-up</li>
                                <li>2. Provide business details</li>
                                <li>3. Complete your KYC (Know Your Customer)</li>
                            </ul>
                            <p>
                                Once you've completed these steps, you'll be able to access and use our digital payment solutions to streamline your business transactions. Let us know if you have any questions or need assistance along the way.
                            </p>
                        </section>
                    </div>
                    <div class="col-md-4">
                        
                    </div>
                </div>
            </div>
        </div>

    )
}

export default GetStarted